export const data = [

    {
        id: 1,
        name: "Party dress",
        searchTerm: "dress",
        price: 300.99,
        image: "https://images.unsplash.com/photo-1566174053879-31528523f8ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8ZHJlc3N8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 2,
        name: "Summer dress",
        searchTerm: "dress",
        price: 204.99,
        image: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8ZHJlc3N8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 3,
        name: "Fancy pants",
        searchTerm: "pants",
        price: 199.99,
        image: "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cGFudHN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 4,
        name: "Jeans",
        searchTerm: "pants",
        price: 100.99,
        image: "https://images.unsplash.com/photo-1584370848010-d7fe6bc767ec?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8dHJvdXNlcnN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 5,
        name: "Cute skirt",
        searchTerm: "skirt",
        price: 300.99,
        image: "https://images.unsplash.com/photo-1592301933927-35b597393c0a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fHNraXJ0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 6,
        name: "Beauty",
        searchTerm: "skirt",
        price: 278.99,
        image: "https://images.unsplash.com/photo-1594226801341-41427b4e5c22?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHNraXJ0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 7,
        name: "Business meeting",
        searchTerm: "shirt",
        price: 285.99,
        image: "https://images.unsplash.com/photo-1608234807905-4466023792f5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fHNoaXJ0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 8,
        name: "Lunch with friends",
        searchTerm: "shirt",
        price: 284.99,
        image: "https://images.unsplash.com/photo-1605881528191-68f38c78e3d3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTkxfHxzaGlydHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 9,
        name: "Carrie shoes",
        searchTerm: "shoes",
        price: 305.99,
        image: "https://images.unsplash.com/photo-1573100925118-870b8efc799d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8aGVlbHN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 10,
        name: "Amanda shoes",
        searchTerm: "shoes",
        price: 305.99,
        image: "https://images.unsplash.com/photo-1627631457335-d1041fd0cb8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fGhlZWxzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 11,
        name: "Miranda shoes",
        searchTerm: "shoes",
        price: 305.99,
        image: "https://images.unsplash.com/photo-1554238113-6d3dbed5cf55?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fGhlZWxzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 12,
        name: "Cute dress",
        searchTerm: "dress",
        price: 305.99,
        image: "https://images.unsplash.com/photo-1582533561751-ef6f6ab93a2e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8c2tpcnR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 13,  
        name: "Pants",
        searchTerm: "pants",
        price: 100.99,
        image: "https://images.unsplash.com/photo-1517438476312-10d79c077509?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NzN8fHBhbnRzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 14,
        name: "Lunch with friends",
        searchTerm: "skirt",
        price: 284.99,
        image: "https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c2tpcnR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
  
    {
        id: 15,
        name: "Lunch with friends",
        searchTerm: "shirt",
        price: 284.99,
        image: "https://images.unsplash.com/photo-1559334417-a57bd929f003?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjIzfHxzaGlydHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
      }
  
  ]